import { styled } from "styled-components";

export const ProfileEditPageTitle = styled.div`
  font-size: 32px;
  line-height: 150px;

  width: 600px;
`;
